import {useEffect, useState} from "react";
import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../shared/ImageComponent";
import noProfile from "../../../images/profileImage.png";
import {userRoleList} from "../../../utils/constants";
import ConversationTab from "./conversationTab";
import {useLocation} from "react-router-dom";
import EmptyState from "../shared/EmptyState";

const Sidebar = ({
  conversations,
  selectedConversation,
  onSelectConversation,
  isSidebarOpen,
  setIsSidebarOpen,
  user,
}) => {
  const [activeTab, setActiveTab] = useState("tout");

  const [Listconversations, setListConversations] = useState([
    ...conversations,
  ]);

  const tabs =
    user?.selectedRole === userRoleList.TECHNICIAN
      ? [
          {id: "tout", label: "Tous"},
          {id: "annonces", label: "Offres envoyées"},
          {id: "direct", label: "Demandes reçues"},
        ]
      : [
          {id: "tout", label: "Tous"},
          {id: "annonces", label: "Offres reçues"},
          {id: "direct", label: "Demandes envoyées"},
        ];

  useEffect(() => {
    if (activeTab === "tout") {
      setListConversations(conversations);
    } else if (activeTab === "annonces") {
      setListConversations([...conversations?.filter((el) => !el?.direct)]);
    } else {
      setListConversations([...conversations?.filter((el) => !!el?.direct)]);
    }
  }, [activeTab, conversations]);
  return (
    <div
      className={`w-1/5 max-[350px]:min-w-[320px]  min-w-[350px] bg-[#F1F2F7] border-r fixed inset-y-0 left-0 z-50 lg:z-0  transition-transform duration-300 lg:relative lg:translate-x-0  ${
        isSidebarOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="w-full flex flex-col gap-5 items-start justify-start !px-2 2xl:!px-4 !mt-10 lg:!mt-5 ">
        <button
          className="w-full flex justify-end p-3 !mt-5 text-gray-500 text-lg hover:text-gray-800 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        >
          <i className="fi fi-rr-arrow-to-left flex items-center"></i>
        </button>
        <div className="bg-white grid grid-cols-3 text-[#7E7E7E] font-semibold text-[13px] leading-3 rounded-full w-full">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`w-full text-center text-wrap py-[6px] leading-[11px] !px-7 rounded-full text-[10px]  font-medium ${
                activeTab === tab.id
                  ? "bg-[#1A64B9] text-white"
                  : "hover:text-[#1A64B9] "
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="flex items-center w-full bg-white rounded-full gap-3 px-4 !py-0">
          <i className="fi fi-rr-search flex items-center"></i>

          <input
            type="text"
            placeholder="Rechercher une conversation"
            className="p-2 border-none flex-grow placeholder:text-[13px] "
          />
        </div>
      </div>
      <ul className="!mt-5 w-full overflow-y-scroll overflow-style-none h-[calc(100vh-250px)] lg:h-[calc(100vh-206px)]">
        {Listconversations?.length ? (
          Listconversations.map((conversation) => (
            <ConversationTab
              closeSideBar={() => setIsSidebarOpen(false)}
              conversation={conversation}
              onSelectConversation={onSelectConversation}
              role={user?.selectedRole}
              key={conversation.id}
              selectedConversation={selectedConversation}
            />
          ))
        ) : (
          <EmptyState className="w-full h-full" animationClassName="max-w-[220px]" />
        )}
      </ul>
    </div>
  );
};

export default Sidebar;
